import { useState } from "react";
import { Grid } from "@mui/material";
import CustomModal from "../../../../../../components/Modal";
import AddIPGroup from "./AddIPGroup";
import IPGroupList from "./IPGroupList";

function IPGroupModal({ modalOpen, setModalOpen, ipGroups, getList }) {
  const [editIP, setEditIP] = useState(null);
  const handleClose = () => {
    setModalOpen(false);
    setEditIP(null);
  };

  return (
    <CustomModal open={modalOpen} handleClose={handleClose}>
      <Grid container spacing={2} rowSpacing={3}
            className="flex-column-md" justifyContent="center"
      >
        <AddIPGroup editIP={editIP} getList={getList} />
        <IPGroupList list={ipGroups} setEditIP={setEditIP} getList={getList} />
      </Grid>
    </CustomModal>
  )
}

export default IPGroupModal;
